import { User } from 'firebase/auth';
import mixpanel from 'mixpanel-browser';

const active = !!import.meta.env.VITE_MIXPANEL;

export const updateMixpanel = async (user?: User) => {
  if (!active) return;

  if (user != null) {
    mixpanel.identify(user.uid);

    mixpanel.people.set({
      $email: user.email,
      $name: user.displayName,
      $created: user.metadata.creationTime,
      $avatar: user.photoURL,
    });
  }
};
